export const retailQuery = `
airPriceGuide(input: $input) {
  error {
    type
    code
    message
  }
  total
  viewers
  records {
    viewers
    destinations {
      airportCode
      cityCode
      stateCode
      countryCode
    }
    origins {
      airportCode
      cityCode
      stateCode
      countryCode
    }
    dates
    cabinClass
    paxChild
    paxInfant
    paxAdult
    currencyCode
    minimumFare {
      isPrivateFare
      currency
      amtPerPax
      commonAttributes {
        takeOffTimes
        landingTimes
      }
      listOfStops {
        sliceId
        stops
      }
    }
  }
}
`

export const airPriceGuideExpressDealOW = `
  query airPriceGuideExpressDealOW($input:AirPriceGuideRequest) {
    ${retailQuery}
  }
`

export const airPriceGuideRetailOW = `
  query airPriceGuideRetailOW($input:AirPriceGuideRequest) {
    ${retailQuery}
  }
`
export const airPriceGuideExpressDealRT = `
  query airPriceGuideExpressDealRT($input:AirPriceGuideRequest) {
    ${retailQuery}
  }
`

export const airPriceGuideRetailRT = `
  query airPriceGuideRetailRT($input:AirPriceGuideRequest) {
    ${retailQuery}
  }
`

export const airPriceGuideNumViewers = `
  query airPriceGuideNumViewers($input:AirPriceGuideRequest) {
    airPriceGuide(input: $input) {
      viewers
    }
  }
`
